var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-template',{attrs:{"data":_vm.data,"title":"Подзаголовок","possible-next":_vm.possibleNext,"is-last":_vm.isLast}},[_c('h2',[_vm._v(_vm._s(_vm.data.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }